import BaseApi from './BaseApi';

class PharmacyQuestionApi extends BaseApi {
  protected getSpecificApiPrefix(): string {
    return 'managers/pharmacy/questions';
  }
}

export default PharmacyQuestionApi;
